import { render, staticRenderFns } from "./Brocure.vue?vue&type=template&id=ef28fb1e"
import script from "./Brocure.vue?vue&type=script&lang=js"
export * from "./Brocure.vue?vue&type=script&lang=js"
import style0 from "./Brocure.vue?vue&type=style&index=0&id=ef28fb1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports